<template>
  <div>
    <div class="mt-2 row">

      <div class="col-12">
        <label class="col-form-label col-sm-12">Begründung</label>
        <textarea v-model="question.explaination" class="form-control" placeholder="Begündung" />
      </div>

      <label class="col-form-label col-sm-6">Type</label>
      <label class="col-form-label col-sm-6">Punkte</label>

      <div class="col-sm-6">
        <select v-model="question.type" class="form-select">
          <option value="radio">Radio</option>
          <option value="checkbox">Checkbox</option>
          <option v-if="false" value="sort">Sortierung</option>
          <option v-if="false" value="input">Eingabefeld</option>
        </select>
      </div>
      <div class="col-sm-6">
        <input v-model="question.points" class="form-control" placeholder="Punkte" />
      </div>
    </div>

    <div class="row mt-2">
      <label class="col-form-label col-sm-1"></label>
      <label class="col-form-label col-sm-9 text-left">Antwort</label>
      <label class="col-form-label col-sm-1 text-left">OK</label>
    </div>

    <div v-for="( answer, idx ) in question.answers" :key="idx" class="row mt-2">
      <div class="col-sm-9 offset-sm-1">
        <input v-model="answer.q" type="text" class="form-control" />
      </div>
      <div class="col-sm-1">
        <div @click.prevent="check_values( idx )">
          <span v-if="answer.a">
            <i class="fa fa-check-square" style="font-size: 36px;"></i>
          </span>
          <span v-else href="#">
            <i class="far fa-square" style="font-size: 36px;"></i>
          </span>
        </div>
      </div>
      <div class="col-sm-1">
        <button @click.prevent="remove_answer(idx)" class="btn btn-secondary">
          <i class="fa fa-trash"></i>
        </button>
      </div>
    </div>

    <div class="row mt-1">
      <div class="col-sm-11 offset-sm-1">
        <button @click.prevent="add_answer" class="btn btn-secondary">
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['parentType', 'parentId', 'contentId', 'id', 'content'],
  data() {
    return {
      question: {
          explaination: '',
          points: 0,
          type: 'radio',
          answers: [
            { q: '', a: false }
          ]
      }
    }
  },
  mounted () {
    let x = null
    try {
      x = JSON.parse( this.content )
      if( x ) this.question = x
      // console.log( 'inside app: content:', this.content, x )
    } catch(e) {
      console.log( e, 'error parsing quiz content')
    }
    // console.log('x', x )
  },
  watch: {
    'question': {
      handler ( n, o ) {
        // console.log( 'inside app watch: ', this.contentId, document.getElementById(this.contentId).textContent )
        document.getElementById(this.contentId).textContent = JSON.stringify(this.question)
      },
      deep: true
    }
  },
  methods: {
      check_values ( index ) {
        if( this.question.type == 'radio' ) {
          this.question.answers[ index ].a = true
          this.question.answers.forEach( ( e, idx ) => {
            if( index !== idx ) e.a = false
          })
        } else {
          this.question.answers[ index ].a = !this.question.answers[ index ].a
        }
      },
      add_answer () {
        this.question.answers.push( { q: '', a: false } )
      },
      remove_answer (idx) {
        this.$delete( this.question.answers, idx )
      }
  },
}
</script>